import * as React from "react";
import {Button, Modal} from "react-bootstrap";

export default class ModalConfirmacion extends React.Component<ModalConfirmacionProps, any> {

    render() {
        return (
            <div>
                <Modal show={this.props.show} onHide={this.props.onCancelar}>
                    <Modal.Header>
                        <Modal.Title>{this.props.titulo}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {this.props.children}
                    </Modal.Body>
                    <Modal.Footer>
                        {this.props.onAceptar &&
                        <Button className={"btns btns-primary"} onClick={this.props.onAceptar}>Aceptar</Button>}
                        <Button className={"btns btns-secondary"} onClick={this.props.onCancelar}>Cancelar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

}

interface ModalConfirmacionProps {
    titulo: String,
    show: boolean,
    onAceptar?: () => void,
    onCancelar?: () => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/ModalConfirmacion.tsx